export default __webpack_public_path__ + "static/media/javascript.0f251d1d.png";